import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=cfdaac18&scoped=true&"
import script from "./Upgrade.vue?vue&type=script&lang=js&"
export * from "./Upgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdaac18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfdaac18')) {
      api.createRecord('cfdaac18', component.options)
    } else {
      api.reload('cfdaac18', component.options)
    }
    module.hot.accept("./Upgrade.vue?vue&type=template&id=cfdaac18&scoped=true&", function () {
      api.rerender('cfdaac18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/views/Upgrade.vue"
export default component.exports